var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content)?_c('div',{staticClass:"cosmobase__hero"},[_c('img',{staticClass:"app--desktop",attrs:{"src":_vm.content.seminarBanner.image,"alt":"Banner image"}}),_c('img',{staticClass:"app--mobile",attrs:{"src":_vm.content.seminarBanner.mobileImage,"alt":"Responsive banner image"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }